var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.prefixCls,on:{"click":_vm.clickBtn}},[_c('div',{class:`${_vm.prefixCls}-text`},[_vm._v(" MORE ")]),_c('div',{class:`${_vm.prefixCls}-arrows`},[_c('img',{attrs:{"src":require("../../assets/image/right.png"),"alt":"more"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }